module.exports = __webpack_public_path__ + "media/images/samples/1280x768/14-f3969c30b8229412e8e607f04889395d.jpg";